export default "__VITE_ASSET__DoQUZhaG__"